import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HostingComponent} from './hosting.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [HostingComponent],
  exports: [HostingComponent]
})
export class HostingModule {
}



// WEBPACK FOOTER //
// ./src/app/components/hosting/hosting.module.ts